import IconAsBgImage from '../IconAsBgImage'

function FileTypeBg({ pureSvg, className, size, ...rest }) {
  const svg = (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="32" height="32">
      <path d="M9 0h14a9 9 0 0 1 9 9v14a9 9 0 0 1-9 9H9a9 9 0 0 1-9-9V9l9-9z" fill="#e2e2e2" fillRule="evenodd" />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsBgImage {...{ svg, className, size }} />
}

export default FileTypeBg
